import axios, { AxiosHeaders } from "axios";
import { tokenRepository } from "@/modules/authentication/repositories/token-repository";
import { decodeToken } from "@/modules/authentication/utils/decode-token";
import { getBaseApiEndpoint } from "@/modules/flavor/actions/get-base-api-endpoint";
import { getLogoutRedirectUri } from "@/modules/authentication/actions/get-logout-redirect-uri";
import { redirect } from "next/navigation";

const httpClient = axios.create({
    headers: {
        Accept: "application/json; charset=utf-8",
    },
    paramsSerializer: { indexes: null },
});

httpClient.interceptors.request.use(async (config) => {
    const baseUrl = await getBaseApiEndpoint();
    return {
        ...config,
        baseURL: baseUrl,
    };
});

httpClient.interceptors.request.use((config) => {
    if (config.headers.has("Content-Type")) return config;

    return {
        ...config,
        headers: new AxiosHeaders({
            ...Object.fromEntries(config.headers),
            "Content-Type":
                config.data instanceof FormData
                    ? "multipart/form-data"
                    : "application/json; charset=utf-8",
        }),
    };
});

httpClient.interceptors.request.use((config) => {
    if (config.method === "GET") {
        return {
            ...config,
            params: {
                ...config.params,
                cacheBuster: Date.now(),
            },
        };
    }
    return config;
});

httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response.status === 401) {
            const { redirect: redirectUri } = await getLogoutRedirectUri();
            redirect(redirectUri);
        }

        return error;
    },
);

httpClient.interceptors.request.use((config) => {
    const token = tokenRepository.read();
    if (token === undefined) return config;

    const data = decodeToken(token);

    // TODO remove this behaviour once Duende Authentication is in place
    const mockHeaders = {
        Role: data.role,
        "User-Name": data.username,
        Company: "CSM",
    };

    return {
        ...config,
        headers: new AxiosHeaders({
            ...Object.fromEntries(config.headers),
            ...mockHeaders,
            Authorization: `Bearer ${token}`,
        }),
    };
});

export { httpClient };
